import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

let isRefreshing = false;
let failedQueue = [];

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('flexboost_user'));
  if (user?.tokens?.accessToken) {
    config.headers.Authorization = `Bearer ${user.tokens.accessToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && error.response?.data?.code === 'TOKEN_EXPIRED' && !originalRequest._retry) {
      if (isRefreshing) return new Promise((resolve, reject) => { failedQueue.push({ resolve, reject }); });
      
      originalRequest._retry = true;
      isRefreshing = true;
      
      try {
        const user = JSON.parse(localStorage.getItem('flexboost_user'));
        const res = await axios.post(`${API_URL}/auth/refresh-token`, { refreshToken: user?.tokens?.refreshToken });
        const newTokens = res.data.data;
        
        user.tokens = newTokens;
        localStorage.setItem('flexboost_user', JSON.stringify(user));
        
        api.defaults.headers.common.Authorization = `Bearer ${newTokens.accessToken}`;
        failedQueue.forEach(p => p.resolve(api(originalRequest)));
        failedQueue = [];
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('flexboost_user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default api;